// 人工调整预览限制为 ±20%，越界提示按原始合计判断。
export const PrepayAdjustLimit = 20;
export const FinalPrepayRateRange = { min: 20, max: 60 };

export const PrepayAdjustWarnText = {
  min: `调整幅度已达下限-${PrepayAdjustLimit}%，超过部分不计入本次变更`,
  max: `调整幅度已达上限${PrepayAdjustLimit}%，超过部分不计入本次变更`,
};
